export default __webpack_public_path__ + "static/media/img-logo-controller.7be0288e.svg";